module.exports = __webpack_public_path__ + "img/esec_logo.57b03c1d.jpg";